import OAuthCallback from '../OAuthCallback.jsx';

const SquareOAuthCallback = ({}) => {
    return <OAuthCallback route="/api/integrations/square/oauth" />;
};

export default SquareOAuthCallback;
